var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "location-card",
      attrs: {
        href: _vm.route("nl.location", { slug: _vm.location.post_name })
      }
    },
    [
      _c("div", { ref: "card", staticClass: "media-container mb-12" }, [
        _c(
          "div",
          {
            ref: "ar",
            staticClass: "ar",
            style: { "padding-top": (_vm.arHeight / _vm.arWidth) * 100 + "%" }
          },
          [
            _c(
              "div",
              { staticClass: "images" },
              [
                _vm.location.acf && _vm.location.acf.image
                  ? [
                      _c("img", {
                        ref: "primary",
                        staticClass: "primary-image",
                        attrs: {
                          src: _vm.location.acf.image.sizes.medium_large,
                          alt: _vm.location.post_title
                        }
                      })
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "title lh-1" }, [
        _vm._v(_vm._s(_vm.location.post_title))
      ]),
      _vm._v(" "),
      _vm.location.acf &&
      _vm.location.acf.highlighted_title &&
      !_vm.$root.isMobile
        ? _c(
            "p",
            { staticClass: "text-dark font-weight-light small mt-8 subtitle" },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.location.acf.highlighted_title) +
                  "\n    "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.location.location_categories &&
      _vm.location.location_categories.length > 0
        ? _c(
            "div",
            {
              key: _vm.location.location_categories.length,
              ref: "categories",
              staticClass: "tag-row mt-12"
            },
            _vm._l(_vm.location.location_categories, function(category, index) {
              return _c(
                "div",
                {
                  key: index,
                  ref: "tags",
                  refInFor: true,
                  staticClass: "tag-col"
                },
                [
                  _c("div", {
                    staticClass: "tag tag-accent-light tag-xs",
                    domProps: { innerHTML: _vm._s(category.name) }
                  })
                ]
              )
            }),
            0
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }